/**
 * Applies an edit payload to a list row without adding modal-only fields.
 * Tables derive their columns from the row shape, so keeping the existing
 * keys prevents editor details from appearing as new list columns.
 */
export function mergeExistingFields<T extends object>(
  item: T,
  updates: object,
): T {
  const merged = { ...item } as Record<string, unknown>;
  const updateFields = updates as Record<string, unknown>;

  Object.keys(item).forEach((field) => {
    if (
      Object.prototype.hasOwnProperty.call(updateFields, field) &&
      updateFields[field] !== undefined
    ) {
      merged[field] = updateFields[field];
    }
  });

  return merged as T;
}
